import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { defaultImageStatus, ImageStatus } from 'src/app/interfaces/api/imageStatus';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../core/api.service';

type QueryParams = Record<string, string | number | boolean | Date | Array<string | number | boolean | Date> | object>;

@Injectable({
  providedIn: 'root'
})

export class ImageStatusService {

  collection = "ImageStatus";
  collectionPath = "images/status";
  imageStatus: ImageStatus[] = [];
  apiUrl = environment.API_URL;
  currentProject: BehaviorSubject<ImageStatus> = new BehaviorSubject<ImageStatus>(defaultImageStatus);

  constructor(
    private apiService: ApiService
  ) { }

  //---GET---//

  getImageStatus(query: QueryParams): Observable<ImageStatus[]> {
    return this.apiService.getCollection(this.collectionPath, "", query);
  }

  getImageStatusById(id: string, key: string | null = null): Observable<ImageStatus> {
    return this.apiService.getCollectionItem(this.collectionPath, "", id);
  }

  searchImageStatus(search: string, query: QueryParams = {}): Observable<ImageStatus[]> {
    return this.apiService.getCollection(this.collectionPath, 'search', { q: search, ...query });
  }

  getImageStatussCount(search: string = "", query: QueryParams): Observable<number> {
    return this.apiService.getCollection(this.collectionPath, 'count', { q: search, ...query });
  }

  //---POST---//

  addStatus(image: any): Observable<any> {
    return this.apiService.postCollectionData(this.collectionPath, "", image);
  }

  //---PUT---//

  updateStatus(status: any): Observable<any> {
    return this.apiService.updateCollectionItem(this.collectionPath, status);
  }

  updateStatuses(statuses: any[]): Observable<any> {
    return this.apiService.updateCollection(this.collectionPath, "many", statuses);
  }

  updateStatusPartial(data: any): Observable<any> {
    return this.apiService.updateCollectionItem(this.collectionPath + "/partial", data);
  }

  //---DELETE---//

  deleteStatus(id: string): Observable<any> {
    return this.apiService.deleteCollectionItem(this.collectionPath, id);
  }

}
